import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'list-chapter-book',
  imports: [],
  templateUrl: './list-chapter-book.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListChapterBookAtom implements OnInit {
  @Input() book: any;

  constructor() {}

  ngOnInit(): void {}
}
